import { PureComponent } from "react"
import { Query } from "react-apollo"
import Link from "next/link"

import PageQuestion from "../../../../containers/page-question/page-question"
import NotFound from "../../../../components/not-found/not-found"

import getParameterByName from "../../../../utils/get-url-param-by-name"
import QUESTION_QUERY from "../../../../queries/question-query"

class Index extends PureComponent {
  render() {
    const { query, me, toggleOverlay } = this.props
    const backToPage = getParameterByName("pageidxref")

    return (
      <Query query={QUESTION_QUERY} variables={{ slug: query.slug }}>
        {({ data, loading }) => {
          if (loading) return <p>loading...</p>
          // unknown, or not approved yet (only its poster sees it then)
          if (!data || !data.question) {
            return (
              <NotFound
                title="We couldn't find that question"
                body="It may be waiting for approval, or the link may be wrong."
                href="/the-nest"
                linkText="See all questions"
              />
            )
          }

          return (
            <div className="index">
              <div className="page__grid">
                <Link
                  as={`/the-nest/${
                    process.browser && backToPage && backToPage !== "1"
                      ? "page-" + backToPage
                      : ""
                  }`}
                  href={`/the-nest/${
                    process.browser && backToPage && backToPage !== "1"
                      ? "?slug=page-" + backToPage
                      : ""
                  }`}
                >
                  <div className="page-question__back">
                    <a>← Back to questions</a>
                  </div>
                </Link>
                <PageQuestion
                  me={me}
                  {...data.question}
                  toggleOverlay={toggleOverlay}
                  query={query}
                />
              </div>
            </div>
          )
        }}
      </Query>
    )
  }
}

Index.propTypes = {}

export { QUESTION_QUERY }
export default Index
